import { Component } from '@angular/core';

@Component({
  selector: 'span[app-button-content]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['button-content.component.scss']
})
export class ButtonContentComponent {}